import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { configuration } from 'src/app/app.config';
import { AuthenticationService } from 'src/app/shared/authentication/auth.service';

@Injectable()
export class ApiHeaderInterceptor implements HttpInterceptor {
  constructor(private _auth: AuthenticationService) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isFlightLogApiRequest(request)) {
      return next.handle(request);
    }
    return this._auth.accessToken$.pipe(
      take(1),
      switchMap((accessToken) => {
        const headers: { [key: string]: string } = {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-API-Version': '1.0',
          'App-Code': 'tci',
          'Company-Code': 'none',
        };
        const contentType = request.headers?.get('Content-Type');
        if (request.headers.has('Content-Type') && contentType === 'undefined') {
          delete headers['Content-Type'];
          request = request.clone({
            headers: request.headers.delete('Content-Type'),
          });
        }
        const impersonatedId = this._auth.impersonatedUserId.value;
        if (impersonatedId != null) {
          headers['x-user-id'] = impersonatedId;
        }
        if (accessToken != null) {
          headers.Authorization = `Bearer ${accessToken}`;
        }
        request = request.clone({
          setHeaders: headers,
        });
        return next.handle(request);
      }),
    );
  }

  private isFlightLogApiRequest(request: HttpRequest<any>) {
    const url = request.url.toLowerCase();
    const isApi = url.includes('api');
    const isFlightLog = url.includes(configuration.flightLog.baseUri.toLowerCase());
    return isApi && isFlightLog;
  }
}
